<div *ngIf="shouldBeVisible()" (click)="hide()"
     style="color: #E35335; padding: 5px; margin-bottom: 5px;"
>
  {{text()}}
</div>
